import { defineComponent as _defineComponent } from 'vue';
import ToolLink from "./ToolLink.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ToolLinkPopover',
    props: {
        target: null,
        toolId: { default: undefined },
        toolVersion: { default: undefined }
    },
    setup(__props) {
        // default boundary of scrollParent doesn't work well at all in the workflow display list
        const boundary = "window";
        return { __sfc: true, boundary, ToolLink };
    }
});
